module.exports = __webpack_public_path__ + "img/Skirt-Back-B7-Db-Fb-Hc.65f9e14c.png";